import { render } from "./GlobalTransactionExceptEuropeView.vue?vue&type=template&id=384f036a"
import script from "./GlobalTransactionExceptEuropeView.vue?vue&type=script&lang=js"
export * from "./GlobalTransactionExceptEuropeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__